"use strict";

var _classCallCheck = require("/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var universal_authenticator_library_1 = require("universal-authenticator-library");

var interfaces_1 = require("./interfaces");

var UALAnchorError =
/*#__PURE__*/
function (_universal_authentica) {
  _inherits(UALAnchorError, _universal_authentica);

  function UALAnchorError(message, type, cause) {
    _classCallCheck(this, UALAnchorError);

    return _possibleConstructorReturn(this, _getPrototypeOf(UALAnchorError).call(this, message, type, cause, interfaces_1.Name));
  }

  return UALAnchorError;
}(universal_authenticator_library_1.UALError);

exports.UALAnchorError = UALAnchorError;